module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/button_checkbox_selected.950a4235.svg";